export const TransactionTypeEnum = {
    0: 'PEDIDO',
    1: 'INGRESO',
};